// Constants for hardcoded values improve readability and maintainability.
const GITHUB_REPO = 'welovealfa/alfa-monorepo';
const GITHUB_BRANCH = 'dev';
const GITHUB_RAW_BASE_URL = `https://raw.githubusercontent.com/${GITHUB_REPO}/refs/heads/${GITHUB_BRANCH}`;

/**
 * Extracts a relative file path from various source string formats.
 */
const extractRelativePath = (source: string): string | null => {
  if (source.startsWith('webpack://')) {
    return source.match(/webpack:\/\/.*?\/(.*)/)?.[1] || null;
  }

  if (source.startsWith('file://')) {
    const decoded = decodeURIComponent(source);
    const pathMatch =
      decoded.match(/\/git\/alfa\/(.*)/) ||
      decoded.match(/(sites\/alfa\/.*)/) ||
      decoded.match(/(packages\/.*)/);
    return pathMatch?.[1] || null;
  }

  if (source.startsWith('./')) {
    return source.substring(2);
  }

  // Handle absolute paths or other formats by removing leading slashes.
  return source.replace(/^\/+/, '');
};

/**
 * Normalizes a path to ensure it fits the project's monorepo structure.
 */
const normalizeMonorepoPath = (path: string): string => {
  if (path.includes('sites/alfa/') || path.startsWith('packages/')) {
    return path;
  }
  if (path.startsWith('src/')) {
    return `sites/alfa/${path}`;
  }
  if (path.startsWith('app/')) {
    return `sites/alfa/src/${path}`;
  }
  // Default fallback for unrecognized path structures.
  return `sites/alfa/src/${path}`;
};

/**
 * Generates a raw GitHub URL for a given source file path.
 */
const getGitHubUrl = (source: string): string | null => {
  try {
    const relativePath = extractRelativePath(source);

    if (!relativePath) {
      // If no path could be extracted, we cannot proceed.
      return null;
    }

    const normalizedPath = normalizeMonorepoPath(relativePath);
    return `${GITHUB_RAW_BASE_URL}/${normalizedPath}`;
  } catch (error) {
    console.warn('Failed to generate GitHub URL:', error);
    return null;
  }
};

export { getGitHubUrl };